export enum AttentionType {
    PRACTICE = 'PRACTICE',
    PRACTICE_MODULE = 'PRACTICE_MODULE',
    MODULE = 'MODULE',
    PRACTICE_MYSELF = 'PRACTICE_MYSELF',
}

/** Prestaciones clásicas del esquema (no módulos). */
export function isClassicPracticeAttentionType(type?: string | null): boolean {
    return type === AttentionType.PRACTICE || type === AttentionType.PRACTICE_MYSELF;
}
